import gql from 'graphql-tag';

export const MODIFY_INVOICE_NUMBER = gql`
  mutation MODIFY_INVOICE_NUMBER($input: UpdateCommissionInput) {
    updateCommission(input: $input) {
      result
    }
  }
`;
